import React from 'react';
import Filters from './Filters';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class FiltersContainer extends React.Component {
    render() {
        const {
            countAll,
            countWithPromotion,
            countUser,
            fairCartProducts,
            selectedProductType,
            selectedSuppliers,
            suppliers,
            searchTerm,
            handleProductTypeSelect,
            handleSelectSuppliers,
            handleSearch,
        } = this.props;

        return (
            <Filters
                allItemsCount={countAll}
                promotionsItemsCount={countWithPromotion}
                clientItemsCount={countUser}
                cartItemsCount={Object.keys(fairCartProducts || {}).length}
                selectedProductType={selectedProductType}
                selectedSuppliers={selectedSuppliers}
                suppliers={suppliers}
                searchTerm={searchTerm}
                onProductTypeChange={handleProductTypeSelect}
                onSuppliersChange={handleSelectSuppliers}
                onSearch={handleSearch}
            />
        );
    }
}

FiltersContainer.propTypes = {
    handleProductTypeSelect: PropTypes.func,
    handleSelectSuppliers: PropTypes.func,
    handleSearch: PropTypes.func,
    fairCartProducts: PropTypes.object,
    selectedProductType: PropTypes.string,
    selectedSuppliers: PropTypes.arrayOf(PropTypes.string),
    suppliers: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            description: PropTypes.string,
        })
    ),
    searchTerm: PropTypes.string,
};

const mapStateToProps = (state) => {
    return {
        countAll: state.fairProducts.countAll,
        countWithPromotion: state.fairProducts.countWithPromotion,
        countUser: state.fairProducts.countUser,
    };
};

export default connect(mapStateToProps)(FiltersContainer);
